import create from 'zustand';
import { persist, StateStorage } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';
import { useNativeWebProps } from '@updater/native-web';

const useDeviceIdStore = create(
  persist(
    () => ({
      id: `device-${uuidv4()}`,
    }),
    {
      name: 'DEVICE_IDS',
      getStorage: () =>
        typeof window !== 'undefined'
          ? localStorage
          : (null as unknown as StateStorage),
    }
  )
);

export const useDeviceId = () => {
  const props = useNativeWebProps();
  const store = useDeviceIdStore();

  return (
    ((props as Record<string, unknown>).deviceId as string | undefined) ||
    store.id
  );
};
